export default "<p class=\"clickable-cell\" (click)=\"clickAction(row)\">{{value | translate }}</p>";